/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ManOfTheMatchUserVotesList = {
    type: 'array',
    contains: {
        type: 'ManOfTheMatchUserVotes',
    },
} as const;
